import invariant from "invariant";

export default class Goal {
	constructor({
		id,
		name,
		completion,
		target,
		mode,
		segment,
	}) {
		invariant(completion, 'completion cannot be empty');

		this._id = id;
		this._name = name;
		this._segment = segment;
		this._completion = completion;
		this._target = target;
		this._mode = mode;
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	getName() {
		return this._name;
	}

	getSegmentID() {
		return this._segment;
	}

	getMode() {
		return this._mode;
	}

	getCurrent() {
		return this._completion.at_expected_date || this._completion.current;
	}

	getCompletion() {
		return Math.abs(this._completion.initial - this.getCurrent());
	}

	getTarget() {
		return Math.abs(this._target);
	}

	getTargetInitialValues() {
		return this._target;
	}

	getDirection() {
		return this._target >= 0 ? 'in' : 'out';
	}
}
